import React from 'react';
import { Checkbox } from 'antd';
import type { BaseOptionType } from './types';
import { ItemWrapper, Label } from './styles';

interface OptionItemProps {
	option: Readonly<BaseOptionType>;
	checked?: boolean;
}

export function OptionItem({ option, checked = false }: Readonly<OptionItemProps>): JSX.Element {
	return (
		<ItemWrapper>
			<Checkbox checked={checked} style={{ pointerEvents: 'none' }} />
			<Label>{option.label}</Label>
		</ItemWrapper>
	);
}
